const zh = {
  title: '邮件接收设置',
  name: '收件人姓名',
  email: '收件人邮箱',
  phone: '收件人手机',
  emailType: '消息类别',
  groups: '群组',
  search: '查询',
  reset: '重置',
  addReveiver: '新增接收者',
  action: '操作',
  selectReceiverType: '请选择收件人类型',
  // isOperator: '请选择系统操作员',
  perator: '操作员',
  noOperator: '非操作员',
  basicInfo: '基础信息',
  operatorName: '操作员名称',
  operatorEmail: '操作员邮箱',
  operatorPhone: '操作员手机',
  receiverName: '收件人姓名',
  receiverEmail: '收件人邮箱',
  receiverPhone: '收件人手机',
  seeAll: '全部',
  edit: '编辑',
  delete: '删除',
  deleteTip: '是否确定删除此消息接收人',
  editReceiver: '编辑接收者',
  msgType: '消息类别',
  allMsgtype: '所有消息类别',
  futureMsgType: '勾选此项后，默认添加未来新增的消息类型，您无需再次手动添加',
  futureNewGroup: '勾选此项后，默认添加未来新增的群组，您无需再次手动添加',

  selectAll: '选择全部',
  group: '群组',
  allGroups: '全部群组',
  groupTip: '消息接收者只会接收到已配置群组的消息',
  groupNotSelected: '未选择',
  groupSelected: '已选择',
  add: '添加',
  comfirm: '确认',
  cancel: '取消',
  editeReveiver: '保存编辑',
  modifySuccess: '修改成功',
  modifyFail: '修改失败',
  addSuccess: '添加成功',
  addFail: '添加失败',
  deleteSuccess: '删除成功',
  typeIncludes: '此类型包含主题有：',
  pickOneMsg: '请至少选择一种消息类型',
  pickOneGroup: '请至少选择一个群组'

}

export default zh
